// extracted by mini-css-extract-plugin
export default {"social":"Contact_social__VyHav","media":"Contact_media__BDcEb","head":"Contact_head__TkkPV","dot":"Contact_dot__DUm78","preview":"Contact_preview__7Cmzy"};